module.exports = __webpack_public_path__ + "img/IMG_0374_FoamcoreMatted.a8766c99.jpg";